import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  errorSubject = new Subject<any>();

  getErrorObservable() {
    return this.errorSubject.asObservable();
  }

  handleError(errorMessage: any) {
    const regexPattern =
      /\/subscription|\/subScription|\/owner-subscription|\/customer-profile|\/blackListLimit|\/query-contract-mobile|\/username-by-pin|\/pin-by-username\//;
    if (!regexPattern.test(errorMessage.url)) {
      this.errorSubject.next(errorMessage);
    }
  }
}
